export const DeviceType = {
    VideoDevice:"VideoDevice",
    AudioOutputDevice:"AudioOutputDevice",
    AudioInputDevice:"AudioInputDevice",
}